import { Loading } from '@fasstech/middle-design-system';
import useGetSimulationPricingsSelfWorkerQuery from './hooks/useGetSimulationPricingsSelfWorkerQuery.js';
import SimulationPricingsSelfWorkerForm from './SimulationPricingsSelfWorkerForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';

const SimulationPricingsSelfWorker = ({
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  usersInformation
}) => {
  const {
    getSimulationPricingsSelfWorker,
    loading: isLoadingGetSimulationPricingsSelfWorker
  } =
    useGetSimulationPricingsSelfWorkerQuery();

  if (isLoadingGetSimulationPricingsSelfWorker) return <Loading/>;

  return (
    <div className="w-full p-0 md:px-4!">
      <SimulationPricingsSelfWorkerForm
        getSimulationPricingsSelfWorker={getSimulationPricingsSelfWorker}
        getMiddleText={getMiddleText}
        getMiddleBoolean={getMiddleBoolean}
        getMiddleNumber={getMiddleNumber}
        usersInformation={usersInformation}
      />
    </div>
  );
};

export default compose(withMiddleFeatures, withGlobalData)(SimulationPricingsSelfWorker);
